import { Injectable } from '@angular/core'
import { FILE_MANAGER_CONSTANTS } from '../../constants/file-manager'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  headerToken: any = ''
  public api_path

  constructor(private httpClient: HttpClient) {
    if ('api_token' in sessionStorage) {
      this.headerToken = sessionStorage.getItem('api_token')
    }
  }

  /**
   * @description Helper method to build HTTP headers with authentication and tenant context
   * @param additionalHeaders Optional additional headers to include
   * @returns HttpHeaders object with Authorization and x-tenant-id (if available)
   */
  private buildHeaders(additionalHeaders?: {
    [key: string]: string
  }): HttpHeaders {
    const token = sessionStorage.getItem('api_token')
    const tenantId = sessionStorage.getItem('tenant_id')

    const headersConfig: any = {
      Authorization: `Bearer ${token}`,
      ...additionalHeaders,
    }

    if (tenantId) {
      headersConfig['x-tenant-id'] = tenantId
    }

    return new HttpHeaders(headersConfig)
  }

  /**
   * @description Helper method to build the full API URL
   * @param endpoint The API endpoint path
   * @returns Full API URL
   */
  private buildUrl(endpoint: string): string {
    return JSON.parse(localStorage.getItem('baseUrl')).api.url + endpoint
  }

  post_Api(URL, body) {
    return this.httpClient.post(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
    })
  }

  delete_Api(URL, body?: any) {
    return this.httpClient.delete(this.buildUrl(URL), {
      headers: this.buildHeaders(),
      body: body,
    })
  }

  put_Api(URL, body) {
    return this.httpClient.put(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
    })
  }

  post_Api_Call(URL, body) {
    return this.httpClient.post(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
      responseType: 'blob',
    })
  }

  get_API_New(URL) {
    return this.httpClient.get(this.buildUrl(URL), {
      headers: this.buildHeaders({
        'Content-Type': 'application/json; charset=utf-8',
      }),
    })
  }

  get_API_Export(URL) {
    return this.httpClient.get(this.buildUrl(URL), {
      headers: this.buildHeaders(),
      responseType: 'arraybuffer',
    })
  }

  patch_Api(URL, body) {
    return this.httpClient.patch(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
    })
  }

  file_DownLoad_Api(URL, body) {
    return this.httpClient.post(this.buildUrl(URL), body, {
      responseType: 'blob',
      headers: this.buildHeaders(),
    })
  }

  fileDownLoad_Api_GZip(URL, body) {
    return this.httpClient.post(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
      responseType: 'arraybuffer',
    })
  }

  file_Upload_Api(URL, body) {
    return this.httpClient.put(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
    })
  }

  file_Upload_Api_Post(URL, body) {
    return this.httpClient.post(this.buildUrl(URL), body, {
      headers: this.buildHeaders(),
    })
  }

  put_SignedUrl_Api(URL, body, contentType) {
    const headers = new HttpHeaders({
      'Content-Type': contentType || 'application/octet-stream',
      'X-Goog-Content-Length-Range': `0,${FILE_MANAGER_CONSTANTS.MAX_UPLOAD_FILE_SIZE}`,
    })
    return this.httpClient.put(URL, body, {
      headers: headers,
    })
  }
}
